import { Field } from "sparkson";

export class Source {
  constructor(
    @Field("s") public src: string,
    @Field("t") public type: string,
  ) {}
}
